module.exports = __webpack_public_path__ + "img/rating2_7-7-2021.7de29e33.jpg";